import {restHelperService} from "./rest-helper.service";

export const sportService = {
    getSports
};

function getSports(sportId = -1) {
    let request = {}
    if(sportId >= 0) {
        request = {
            "sportId": sportId
        };
    }

    return restHelperService.createGetRequest("/rest/data/sport", request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}